<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card>
          <v-toolbar class="primary" dark>
            <v-toolbar-title class="title">Edit Text for the Welcome Screen</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!editMode"
              flat
              dark 
              outline
              @click="editMode = !editMode">
                Edit
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-textarea
              v-model="formData.headingText"
              auto-grow
              rows=1
              :readonly="!editMode"
              label="Heading Text">
            </v-textarea>
            <v-textarea
              v-model="formData.bodyText"
              auto-grow
              rows=3
              :readonly="!editMode"
              label="Body Text">
            </v-textarea>
            <v-textarea
              v-model="formData.contactText"
              auto-grow
              rows=1
              :readonly="!editMode"
              label="Contact Text">
            </v-textarea>
            <v-textarea
              v-model="formData.contactEmail"
              auto-grow
              rows=1
              :readonly="!editMode"
              label="Conatct Email">
            </v-textarea>
          </v-card-text>
          <v-card-actions v-if="editMode">
            <v-btn
              outlined
              color="secondary"
              dark
              @click="cancelChanges">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="primary"
              dark
              @click="saveChanges">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import firebase from 'firebase'

export default {
  name: 'welcomeAdmin',
  data () {
    return {
      formData: {},
      editMode: false
    }
  },
  computed: {
    welcomeText: function () {
      return this.$store.getters.getWelcomeText
    }
  },
  created () {
    this.loadDataIntoForm()
  },
  methods: {
    returnToMenu () {
      this.$router.push('/home')
    },
    loadDataIntoForm () {
      // clear out formData before reloading from welcomeText
      this.formData = {}
      this.formData = Object.assign({}, this.welcomeText)

      // console.log("Form data after",this.formData)

      // console.log("Form and config are the same - ",Object.is(this.welcomeText,this.formData))
    },
    cancelChanges () {
      this.$forceUpdate()
      this.loadDataIntoForm()
      this.editMode = false
    },
    saveChanges () {
      this.$forceUpdate()
      this.$store.dispatch('saveWelcomeText', this.formData)
      this.editMode = false
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.card-form-list {
    margin-top: 10px;
}

.card-study-site {
    margin-top: 10px;
}
</style>
